/**
 * Redirect target for the /welcome route given the auth gate, or null to
 * render the wizard. Onboarding is authenticated-only: an expired session
 * lands on login, not an error.
 */
export function resolveWelcomeRouteRedirect(isAuthenticated: boolean): "/login" | null {
  if (isAuthenticated) {
    return null;
  }
  return "/login";
}
